import { render, staticRenderFns } from "./orgRelStaff.vue?vue&type=template&id=1fd2a520&scoped=true"
import script from "./orgRelStaff.vue?vue&type=script&lang=js"
export * from "./orgRelStaff.vue?vue&type=script&lang=js"
import style0 from "./orgRelStaff.vue?vue&type=style&index=0&id=1fd2a520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2a520",
  null
  
)

export default component.exports